import React from 'react';
const Container =  ({ children }) => (
  <div style={{ maxWidth: '1024px', margin: '20px auto 0 auto' }}>
    {children}
  </div>
);

export default Container;